import axios from 'axios';
import cfac22 from '../cfac22';

export async function getEstablishmentItem(establishmentId) {
  const config = {
    method: 'post',
    url: cfac22('API_HOST_V2') + '/establishments/get/getEstablishmentItem',
    headers: {
      'Full-Url': window.location.href,
    },
    data: { establishmentId, partnerId: cfac22('partnerId') },
    withCredentials: true,
  };

  return new Promise((resolve, reject) => {
    axios(config)
      .then(function (response) {
        resolve(response.data.response);
      })
      .catch(function (error) {
        reject(error.response.data);
      });
  });
}

